// Main application JavaScript entry point
import '../css/app.css';
import MainMenu from './lib/main-menu.js';
import MoveTopPager from './lib/move-top-pager.js';

new MainMenu();
new MoveTopPager();

// Hot Module Replacement (HMR) support
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR Update');
  });
}

// Your custom JavaScript here
document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('js');
});
